import Header from '@/core/components/Header/Header';

export default Header;
